module.exports = "/packs/images/sprites/general~8f65496ef22e898ab65aa927801e9cbe.svg";